<template>
    <v-btn :to="(to)? to : null" v-ripple="false" :color="color" :loading="loading" @click="clicked" class="white--text drop-button"
        :disabled="!activeButton"
        :class="{'button-primary-active' : activeButton, 'button-primary-inactive': !activeButton}">
        <p class="text-wrap ma-0">
            <slot></slot>
        </p>
    </v-btn>
</template>
<script>
export default {
    props:{
        activeButton:{
            type: Boolean,
            default: true
        },
        goToHref:{
            type:String,
        },
        loading:{
            type:Boolean,
            default: false
        },
        to:{
            type:String
        },
        landing:{
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: '#2F80ED',
        },
    },
    data:()=>{
        return {

        }
    },
    methods: {
        clicked(){
            if(this.goToHref){
                if(this.landing)
                    location.href = this.goToHref;
                else
                    location.href = location.origin+this.goToHref;
            } else {
                this.$emit('clickBtn');
            }
        }
    }
}
</script>
<style>
.disable-events {
    pointer-events: none
}
</style>
